<div class="content p-24" fusePerfectScrollbar>
    <div class="page-layout simple fullwidth inner-scroll">
        <form class="form" [formGroup]="formulario" autocomplete="off">
            <mat-form-field class="full-width">
                <span matPrefix>
                    <mat-icon>search</mat-icon>
                </span>

                <mat-select
                    formControlName="grupo"
                    (selectionChange)="cargarServicio($event)"
                >
                    <mat-option [value]="-1"> Seleccione... </mat-option>
                    <mat-option *ngFor="let grupo of grupos" [value]="grupo.id">
                        {{ grupo.descripcion }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </form>
    </div>
</div>
